<template>
  <transition name="fade">
    <div class="photo-viewer-overlay" v-if="photo" @click.self="$emit('close')">
      <div class="photo-viewer-modal">
        <button class="close-button" @click="$emit('close')">✖</button>

        <div v-if="isLoading" class="spinner-container">
          <div class="spinner"></div>
        </div>

        <img
          v-show="!isLoading"
          :src="photo"
          alt="Large photo"
          @load="onImageLoad"
        />
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'PhotoViewer',
  props: {
    photo: String,
  },
  data() {
    return {
      isLoading: true,
    };
  },
  methods: {
    onImageLoad() {
      this.isLoading = false;
    },
  },
  watch: {
    photo: {
      handler() {
        this.isLoading = true;
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
.photo-viewer-modal {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 100px;
  min-height: 100px;
}

.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinner {
  border: 5px solid rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  border-top-color: #fff;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.photo-viewer-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 200;
  padding: 1rem;
}

.photo-viewer-modal {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  width: auto;
  height: auto;
  border-radius: 12px;
  overflow: hidden;
}

.photo-viewer-modal img {
  max-width: 100%;
  max-height: inherit;
  display: block;
  margin: 0 auto;
  border-radius: 12px;
  object-fit: contain;
}

.close-button {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  background: none;
  border: none;
  font-size: 2rem;
  color: white;
  cursor: pointer;
  z-index: 201;
}

/* Fade transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
